import { defineStore } from 'pinia';
import { UPDATE_GIFT_CARD_OPTIONS, SHOW_GIFT_CARD_OPTIONS_SLIDEOUT } from '~/types/actions';
import {
  SET_GIFT_CARD_OPTIONS,
  SET_GIFT_CARD_OPTIONS_UPDATE_ERROR,
  SET_GIFT_CARD_OPTIONS_UPDATE_SUCCESS,
  SET_GIFT_CARD_OPTIONS_UPDATE_ERROR_DESCRIPTION,
  SET_REFRESH_REGISTRANT_MY_GIFT,
} from '~/types/mutations';
import { generateLogin365FingerPrint } from '~/utils/PersistentLoginUtil';
import { httpUpdateAPIHeaders } from '~/utils/APIUtil';
import { SoftSignInValidation } from '~/utils/SoftSignInValidation';
import $http from '@vue-util/http';
import { useSlideoutStore } from '@nuxt-common/atomic-ui/app/stores/useSlideoutStore';
import { getStore } from '~/utils/storeMapping';

const REGISTRANT_GIFT_CARD_ENDPOINT = '/regsvc/registry/api/v1/registry';

export const useGiftCardStore = defineStore('giftCard', {
  state: () => ({
    giftCardOptionsUpdateError: false,
    giftCardOptionsUpdateSuccess: false,
    giftCardOptionsUpdateErrorDescription: '',
    refreshRegistrantMyGift: false,
  }),
  actions: {
    [SET_GIFT_CARD_OPTIONS_UPDATE_ERROR](data) {
      this.giftCardOptionsUpdateError = data;
    },
    [SET_GIFT_CARD_OPTIONS_UPDATE_SUCCESS](data) {
      this.giftCardOptionsUpdateSuccess = data;
    },
    [SET_GIFT_CARD_OPTIONS_UPDATE_ERROR_DESCRIPTION](data) {
      this.giftCardOptionsUpdateErrorDescription = data;
    },
    [SET_REFRESH_REGISTRANT_MY_GIFT](data) {
      this.refreshRegistrantMyGift = data;
    },
    async [UPDATE_GIFT_CARD_OPTIONS]({ payload, module }) {
      try {
        const mappedStore = await getStore(module);

        this[SET_GIFT_CARD_OPTIONS_UPDATE_SUCCESS](false);
        this[SET_GIFT_CARD_OPTIONS_UPDATE_ERROR](false);
        const login365FingerPrint = await generateLogin365FingerPrint();
        const response = await $http.put(`${REGISTRANT_GIFT_CARD_ENDPOINT}`, payload, {
          headers: httpUpdateAPIHeaders(payload, login365FingerPrint),
        });
        const isError = response?.data?.errors || response?.data?.error;
        if (isError) {
          this[SET_GIFT_CARD_OPTIONS_UPDATE_ERROR](true);
          this[SET_GIFT_CARD_OPTIONS_UPDATE_ERROR_DESCRIPTION](isError?.[0]?.description);
        } else {
          mappedStore[SET_GIFT_CARD_OPTIONS](payload.basicInfoUpdate);
          this[SET_GIFT_CARD_OPTIONS_UPDATE_SUCCESS](true);
          this[SET_GIFT_CARD_OPTIONS_UPDATE_ERROR_DESCRIPTION]('');
        }
      } catch (error) {
        SoftSignInValidation(error);
        this[SET_GIFT_CARD_OPTIONS_UPDATE_ERROR](true);
        this[SET_GIFT_CARD_OPTIONS_UPDATE_ERROR_DESCRIPTION](error?.response?.data?.errors?.[0]?.description);
      }
    },
    async [SHOW_GIFT_CARD_OPTIONS_SLIDEOUT]({ refresh }) {
      const slideoutStore = useSlideoutStore();

      slideoutStore.toggle('gift-card-options');
      this[SET_REFRESH_REGISTRANT_MY_GIFT](refresh);
    },
  },
});
